<template>
  <div>
    <div id="data-upload-control" class="clearfix">
      <div class="btn btn-sm btn-outline-primary float-right position-relative" @click="exportChannelConfig">
        <i class="fa fa-folder-open-o" aria-hidden="true"></i>
        导出采集配置
      </div>
    </div>

		<nav class="nav nav-tabs justify-content-end">
      <a class="nav-item nav-link" :class="{active: view === 'device'}" href="javascript:;" @click="changeView('device')">设备视图</a>
			<a class="nav-item nav-link" :class="{active: view === 'interface'}" href="javascript:;" @click="changeView('interface')">接口视图</a>
		</nav>
		<div class="tab-content" id="nav-tabContent">
			<div class="tab-pane fade active show" id="nav-data-upload">
        <!-- device -->
        <div class="row">
          <div class="col-sm-5">
            <div class="card">
              <div class="card-header">
                {{ view === 'device' ? '设备/数据树' : '接口树' }}
              </div>
              <div class="card-body">
                <device-tree v-if="view === 'device'"></device-tree>
                <interface-tree v-if="view === 'interface'"></interface-tree>
              </div>
            </div>
          </div>

          <div class="col-sm-7">
            <div class="card">
              <div class="card-header">
                参数配置
              </div>
              <div class="card-body">
                <global-forms id="forms"></global-forms>
              </div>
            </div>
          </div>
        </div>

      </div>
		</div>

  </div>
</template>

<script>
  import DeviceTree from '@/components/home/trees/device-tree'
  import InterfaceTree from '@/components/home/trees/interface-tree'
  import Forms from '@/components/home/forms'

  import db from '@/extensions/db'
  import axios from 'axios'
  import config from '@/config'

  export default {
    data () {
      return {
        view: 'device' // device | interface
      }
    },
    created () {
    },
    components: {
      'global-forms': Forms,
      DeviceTree,
      InterfaceTree
    },
    methods: {
      changeView (view) {
        if (this.view !== view) {
          this.view = view
          this.$emitter.emit('updateForm', '')
        }
      },
      alertSuccess () {
        this.$notify({
          group: 'alert',
          type: 'success',
          title: '提示',
          text: '保存成功！'
        })
      },
      async exportChannelConfig () {
        try {
          let data = await db.generateConfigWithoutMetadata()
          let resp = await axios.post(config.network.config.url, data)

          this.$download('app-config-collect.json', JSON.stringify(resp.data, null, 4))
        } catch (err) {
          if (typeof err.response === 'object') {
            alert(err.response.data)
          } else {
            alert(`Error: ${err.message}`)
          }
        }
      }
    }
  }
</script>

<style scoped>
  #data-upload-control {
    margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/tabs/data-collect.vue